import appConfig from 'utils/appConfig';

// We are creating the script tag that loads the login assets in js rather than putting it directly in the html
// if this was in index.html, loginAssetsURL would be required to be set at build-time, per environment
// putting it here in js allows us to read loginAssetsURL at run-time, which is a requirement of the ci/cd pipeline
const theSenateLoaded = new Promise((resolve) => {
	if (window.TheSenate) {
		resolve();
		return;
	}
	if (!appConfig.loginAssetsURL) {
		console.warn('loginAssetsURL missing. TheSenate will not be loaded');
		resolve();
		return;
	}
	const script = document.createElement('script');
	script.src = `${appConfig.loginAssetsURL}/cross/TheSenate.min.js`;
	script.onload = resolve;
	script.onerror = resolve;
	document.head.appendChild(script);
});

export default theSenateLoaded;
